import React from "react";
import CreateEditSubAdminPage from "../../entities/SubAdminPage/CreateEditSubAdmin";

const CreateEdit = () => {
  return <CreateEditSubAdminPage />;
};

export default CreateEdit;
